<div class="footer-light" style="padding-top: 30px;">
    <div class="footer-container" style="text-align: center;">
        <div class="footer-item text" style="color: #313945;">
            © 2024 | UTIC SRS 
        </div>
    </div>
</div>